import { BoardKind, isBoardKind } from "./boards.ts";

export const WorkroomKey = BoardKind;
export type WorkroomKey = typeof WorkroomKey.Type;
export const workroomBoardKind = (key: string | null | undefined): BoardKind | null =>
  isBoardKind(key) ? key : null;
export const workroomInjectionLayerKey = (key: string): string => `room/${key}`;

export {
  canonicalWorkroomKey,
  canonicalRoomKind,
  normalizeWorkroomReference,
  hasConflictingWorkroomKeys,
  canonicalWorkroomLabel,
  normalizeWorkroomInputReference,
} from "./workroomReferences.ts";
